export enum ScreenSize {
    Unknown = 0,
    Mobile = 1,
    Tablet = 2,
    Desktop = 3
}
